import React, { useEffect } from "react";
import styles from "./CardByArea.module.scss";

interface CardByAreaProps {
  location: string;
  numOfListings: number;
}

const CardByArea = ({ location, numOfListings }: CardByAreaProps) => {
  const getBackgroundImage = (location: string) => {
    switch (location) {
      case "Cancún":
        return require("../../Images/cancun.jpg");
      case "Mérida":
        return require("../../Images/merida.jpg");
      case "Playa del Carmen":
        return require("../../Images/playa-del-carmen.jpg");
      case "Puerto Morelos":
        return require("../../Images/puerto-morelos.webp");
      case "Tulum":
        return require("../../Images/tulum.webp");
      default:
        return require("../../Images/tulum.webp");
    }
  };

  const backgroundImageUrl = getBackgroundImage(location);

  return (
    <div
      onClick={() => window.location.href = `/listings?location=${location}`}
      className={styles.container}
      style={{
        backgroundImage: `linear-gradient(
          to right,
          rgba(0, 0, 0, 0.45),
          rgba(0, 1, 73, 0.05)
        ), url(${backgroundImageUrl})`,
      }}
    >
      <p className={styles.location}>{location}</p>
      <p className={styles.numOfListings}>
        {numOfListings} {numOfListings === 1 ? "propiedad" : "propiedades"}
      </p>
    </div>
  );
};

export default CardByArea;
